import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import Pagination from './orderHistory/pagination';
import tspColumns from './orderHistory/_columns';
import { useProfile } from '../../../customHooks/useProfile';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

const OrderHistory = ({}) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const { orderHistory, loading } = useProfile();
  return (
    <>
      {loading ? (
        <></>
      ) : (
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              padding: '15px',
              background:
                'linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.45) 100%)',
              borderRadius: '15px',
              boxShadow: '0px 4px 4px 0px #00000026',
              height: '100%',
              padding: '20px',
              boxSizing: 'border-box',
            }}
          >
            <Typography sx={{ fontSize: '20px', fontWeight: '500' }}>
              Order History
            </Typography>
            <DataGrid
              sx={{
                width: '100%',
                height: '400px',
                border: 'none',
                '& .column-cell': {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontSize: '12px',
                  fontWeight: '500',
                  whiteSpace: 'nowrap',
                  width: '100%',
                  borderBottom: '1px solid white',
                },
                '& .header-cell': {
                  fontSize: '14px',
                  fontWeight: 'bold',

                  width: '100%',
                  headerAlign: 'center',
                  align: 'Right',

                  borderBottom: '3px solid white',
                },
                '& .action-cell': {
                  fontSize: '14px',
                  fontWeight: 'bold',

                  borderBottom: '3px solid white',
                },
                '& .css-t89xny-MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 'bold',
                },
                '& .MuiDataGrid-cell:focus': {
                  outline: 'none',
                },
                '& .MuiDataGrid-columnHeader:focus': {
                  outline: 'none',
                },
              }}
              rows={orderHistory?.map((entry, index) => {
                return { ...entry, id: index };
              })}
              columns={tspColumns}
              rowHeight={30}
              hideFooter
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: isMdUp ? 'right' : 'center',
                py: 0.5,
              }}
            >
              <Pagination />
            </Box>
          </Box>
        </>
      )}
    </>
  );
};

export default OrderHistory;
